import {
    ADD_VOUCHER_FAIL,
    ADD_VOUCHER_SUCCESS,
    DELETE_VOUCHER_FAIL,
    DELETE_VOUCHER_SUCCESS,
    EXPORT_VOUCHER_FAIL,
    EXPORT_VOUCHER_SUCCESS,
    GET_VOUCHER_DETAILS_FAIL,
    GET_VOUCHER_DETAILS_SUCCESS,
    GET_VOUCHER_LISTING_FAIL,
    GET_VOUCHER_LISTING_SUCCESS,
    RESET_VOUCHER_ATTACHMENT_STATE,
    RESET_VOUCHER_STATE,
    UPDATE_VOUCHER_FAIL,
    UPDATE_VOUCHER_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    voucherListing: [],
    voucherDetails: [],
    addVoucher: [],
    updateVoucher: [],
    deleteVoucher: [],
    exportVoucher: [],
    error: [],
}

const Voucher = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_VOUCHER_LISTING_SUCCESS:
            return {
                ...state,
                voucherListing: action.payload
            }
        case GET_VOUCHER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_VOUCHER_DETAILS_SUCCESS:
            return {
                ...state,
                voucherDetails: action.payload
            }
        case GET_VOUCHER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_VOUCHER_SUCCESS:
            return {
                ...state,
                addVoucher: action.payload
            }
        case ADD_VOUCHER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_VOUCHER_SUCCESS:
            return {
                ...state,
                updateVoucher: action.payload
            }
        case UPDATE_VOUCHER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_VOUCHER_SUCCESS:
            return {
                ...state,
                deleteVoucher: action.payload
            }
        case DELETE_VOUCHER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_VOUCHER_SUCCESS:
            return {
                ...state,
                exportVoucher: action.payload
            }
        case EXPORT_VOUCHER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_VOUCHER_ATTACHMENT_STATE:
            return {
                ...state,
                exportVoucher: [],
                error: [],
            }
        case RESET_VOUCHER_STATE:
            return {
                ...state,
                voucherListing: [],
                voucherDetails: [],
                addVoucher: [],
                updateVoucher: [],
                deleteVoucher: [],
                exportVoucher: [],
                error: [],
            }
        default:
            return state
    }
}

export default Voucher
